import { environment } from '../../../environments/environment';
import { CardViewer } from './board-v3.types';
import { formatFullName } from '../../helpers';

/** app-avatar resolves file keys itself, so the raw `avatar_url` is enough */
export function getBoardPresenceViewerAvatarUrl(viewer: CardViewer): string | undefined {
  return viewer.avatar_url || undefined;
}

export function getBoardPresenceViewerTitle(viewer: CardViewer): string {
  return formatFullName(viewer.first_name, viewer.last_name) || viewer.email || '—';
}

export function getBoardPresenceViewersTitle(viewers: CardViewer[]): string {
  return viewers
    .map((viewer) => getBoardPresenceViewerTitle(viewer))
    .filter(Boolean)
    .join(', ');
}
